import { Tooltip } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { useSandboxModeContext } from '../../contexts'

interface SandboxBlockedTooltipProps {
  children: ReactNode
}

/**
 * Wraps a drawer action that's inert in sandbox mode (New Invoice, New Receipt, manual
 * payment) so it stays visually active but explains why nothing happens when clicked,
 * instead of a confirmation dialog or a disabled/greyed-out state. On the real route it
 * passes children through unchanged — real users should never see this tooltip.
 */
export const SandboxBlockedTooltip = ({ children }: SandboxBlockedTooltipProps): ReactElement => {
  const { t } = useTranslation()
  const sandbox = useSandboxModeContext()

  if (!sandbox) {
    return <>{children}</>
  }

  return <Tooltip label={t('bank_transactions.sandbox.blocked_action_tooltip')}>{children}</Tooltip>
}
